import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";

import CardBody from "../CardBody/CardBody";
import CardHeader from "../CardHeader/CardHeader";
import CardMenu from "../CardMenu/CardMenu";

import "./Card.scss";

const Card = ({
  title,
  subTitle,
  image,
  collapsed = false,
  defaultCategory = "Summary",
  categories,
  defaultLayout = "1col",
  changeLayoutForCategories = ["Tech Stack"],
}) => {
  const [isCollapsed, setCollapsed] = useState(collapsed);
  const [selectedCategory, setSelectedCategory] = useState(defaultCategory);

  const collapseHandler = useCallback(() => setCollapsed(!isCollapsed), [
    isCollapsed,
  ]);

  const cardBody = categories
    .map((category) => {
      category.body.layout = defaultLayout;
      if (changeLayoutForCategories.includes(category.name)) {
        category.body.layout = "2col";
      }
      return category;
    })
    .find((category) => category.name === selectedCategory).body;

  return (
    <div className="card" data-testid="card">
      <CardHeader
        title={title}
        subTitle={subTitle}
        image={image}
        isCollapsed={isCollapsed}
        collapseHandler={collapseHandler}
      />
      <CardMenu
        categories={categories}
        selectedCategory={selectedCategory}
        categorySelectedHandler={setSelectedCategory}
      />
      <CardBody
        title={cardBody.title}
        paragraph={cardBody.paragraph}
        collection={cardBody.collection}
        isCollapsed={isCollapsed}
        layout={cardBody.layout}
      />
    </div>
  );
};

Card.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(
    PropTypes.exact({
      name: PropTypes.string.isRequired,
      body: PropTypes.object.isRequired,
    })
  ).isRequired,
  collapsed: PropTypes.bool,
  defaultCategory: PropTypes.string,
  defaultLayout: PropTypes.oneOf(["1col", "2col"]),
  changeLayoutForCategories: PropTypes.arrayOf(PropTypes.string),
};

export default Card;
